module.exports = __webpack_public_path__ + "img/carrusel-1.f8bb893b.png";